(function () {
  'use strict';

  /*
   * Stable species identity and safe default states.
   * Product records are supplied separately by Liquid from verified Shopify
   * product references. This file deliberately contains no product handles,
   * IDs, titles, prices, or product availability claims.
   */
  window.INNERMON_SPECIES_COMMERCE = {
    config: {
      notify_storage_ready: false,
      launch_tag: 'innermon-launch-v01'
    },
    species: {
      snail: {
        internal_key: 'snail', public_name: 'Corporate Snail', registry_status: 'documented', launch_collection: true,
        merch_status: 'preparing', notify_eligible: true, current_master_asset: 'innermon-snail-master.png'
      },
      boss_dino: {
        internal_key: 'boss_dino', public_name: 'Executive T-Rex', registry_status: 'documented', launch_collection: true,
        merch_status: 'preparing', notify_eligible: true, current_master_asset: 'innermon-boss-dino-master.png'
      },
      parrot: {
        internal_key: 'parrot', public_name: 'Copycat Parrot', registry_status: 'documented', launch_collection: true,
        merch_status: 'preparing', notify_eligible: true, current_master_asset: 'innermon-parrot-master.png'
      },
      sloth: {
        internal_key: 'sloth', public_name: 'Approval Sloth', registry_status: 'documented', launch_collection: true,
        merch_status: 'preparing', notify_eligible: true, current_master_asset: 'innermon-sloth-master.png'
      },
      peacock: {
        internal_key: 'peacock', public_name: 'Gloryhog Peacock', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-peacock-master.png'
      },
      meerkat: {
        internal_key: 'meerkat', public_name: 'Gossipy Meerkat', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-meerkat-master.png'
      },
      starfish: {
        internal_key: 'starfish', public_name: 'Oops Starfish', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-starfish-master.png'
      },
      turtle: {
        internal_key: 'turtle', public_name: 'Selective Turtle', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-turtle-master.png'
      },
      jellyfish: {
        internal_key: 'jellyfish', public_name: 'Protected Jellyfish', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-jellyfish-master.png'
      },
      octopus: {
        internal_key: 'octopus', public_name: 'Super Octopus', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-octopus-master.png'
      },
      puppy_intern: {
        internal_key: 'puppy_intern', public_name: 'Puppy Intern', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-puppy-intern-master.png'
      },
      goldfish: {
        internal_key: 'goldfish', public_name: 'Difficult Goldfish', registry_status: 'documented', launch_collection: false,
        merch_status: 'in_the_lab', notify_eligible: true, current_master_asset: 'innermon-goldfish-master.png'
      }
    }
  };
})();
